<template>
	<v-container fill-height>
	<v-row dense>
	<v-col
		v-for="card in cards"
		:key="card.title"
		:cols="card.flex"
	>
		<v-card
			class="mx-auto"
			height="100%"
		>
			<v-toolbar
				color="blue lighten-1"
				dark
				dense
				flat
			>
				<v-toolbar-title class="body-2">{{card.year}}</v-toolbar-title>
			</v-toolbar>
			<v-card-text>
				<div>{{card.maker}}</div>
				<div class="title text--primary">
				『{{card.title}}』
				<a v-if="card.link" :href="card.link" target="blank" style="text-decoration:none">
					<v-icon medium style="text-decoration:none">mdi-open-in-new</v-icon>
				</a>
				</div>
				<v-img
					v-if="card.image" :src="card.image"
					class="white--text align-end"
					width="100%"
				>
				</v-img>
				<ul style="border-top:1px gray solid">
					<li
						v-for="(duty,i) in card.duties"
						:key="i"
					>
					{{duty}}
					</li>
				</ul>
			</v-card-text>
		</v-card>
	</v-col>
	</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'WorkHistory',

		data: () => ({
			cards: [
				{ year: '2024年8月', title: '冒険者配信中！#01', maker: '(オリジナル同人漫画をKindleインディーズに公開)', duties: ['制作全般'], image: require('@/assets/bh01.jpg'), link: "https://www.amazon.co.jp/dp/B0DBV9Z3YX", flex: 6 },
				{ year: '2017年～2019年6月', title: 'アートワール 魔法学園の乙女たち', maker: 'tencross', duties: ['企画','シナリオチーフ','ゲームデザイン','レベルデザイン','フロントエンド設計','開発ツール製作','その他'/*,'主な担当シナリオ：基本ストーリー','主な担当プロット：初期ヒロインストーリー'*/], /*image: require('@/assets/artwhirl.jpg'),*/ link:"http://pc-play.games.dmm.com/play/artwhirl/", flex: 12 },
				{ year: '2014年～2016年', title: 'ようこそ!恋ヶ崎女学園へ', maker: 'tencross', duties: ['企画','シナリオチーフ','ゲームデザイン（イベント）','レベルデザイン（イベント）','その他'/*,'主な担当シナリオ：幕ノ内 桜子・氷室 静乃・イベント全般','主な担当プロット：初期メインヒロイン・サブヒロイン'*/], link:"http://pc-play.games.dmm.co.jp/play/jyogakuen/", flex: 12 },
				//'主な担当シナリオ（イベント）：プール＆夏祭り・	恋と友情の体育祭！・聖夜のお菓子箱（藤沢しのぶ）・バレンタイン狂想曲・ナナのご主人様観察日誌・わいわい夏合宿！・恋ヶ崎PR計画・つむぎのスウィートチャレンジ・湯けむり 追憶 修学旅情'
				{ year: '2013年', title: 'Airs XG（Android版）', maker: 'tencross', duties: ['プログラミング',/*'CG',*/'スクリプト'], /*image: require('@/assets/airs_xg-android.jpg'),*/ link:"https://www.tencross.co.jp/products/", flex: 6 },
				{ year: '2012年', title: 'Airs（Android版）', maker: 'tencross', duties: ['プログラミング',/*'原画','CG',*/'スクリプト'], /*image: require('@/assets/airs-android.jpg'),*/ link:"https://www.tencross.co.jp/products/", flex: 6 },
				{ year: '2010年', title: 'Airs XG', maker: 'tencross', duties: ['企画','シナリオ','原画','CG','スクリプト'], /*image: require('@/assets/airs_xg.jpg'),*/ link:"https://www.tencross.co.jp/products/", flex: 12 },
				{ year: '2009年', title: 'Airs', maker: 'tencross', duties: ['企画','シナリオ','原画','CG'], /*image: require('@/assets/airs.jpg'),*/ link:"https://www.tencross.co.jp/products/", flex: 12 },
				{ year: '2007年', title: 'Clover Point', maker: 'Meteor', duties: ['CGチーフ','シナリオ構成'], link: "https://www.a-cute.jp/OfficialDownloadStore/meteor/?pg=2&icd=4908", flex: 12 },
				{ year: '2006年', title: 'ちょこっと☆ばんぱいあ！', maker: 'Meteor', duties: ['イベント用テレカCG'], flex: 6 },
				{ year: '2006年', title: 'フォセット - Cafe au Le Ciel Bleu -', maker: '戯画', duties: ['イベント用テレカ＆紙袋CG','雑誌用ピンナップCG'], flex: 6 },
				{ year: '2006年', title: 'いな☆こい！', maker: 'Whirlpool', duties: ['イベントCG'], flex: 6 },
				{ year: '2006年', title: 'この青空に約束を―', maker: '戯画', duties: ['雑誌用ピンナップCG'], flex: 6 },
				{ year: '2005年', title: 'はぴくり', maker: 'Rondo Bell', duties: ['イベントCG','パッケージCG'], flex: 6 },
				{ year: '2005年', title: 'angel breath', maker: '戯画', duties: ['パッケージCG'], flex: 6 },
				{ year: '2005年', title: '夜明け前より瑠璃色な', maker: 'オーガスト', duties: ['雑誌用パッケージCG','キャラクター＆イベントCG','テレカCG'], link: "https://august-soft.com/yoake/", flex: 6 },
				{ year: '2004年', title: 'お嬢様組曲', maker: 'Symphony', duties: ['CGチーフ','シナリオ','スクリプト','システムグラフィック','UI設計','ウェブデザイン'/*,'主な担当シナリオ：白河 沙絵・西九条 小雪'*/], link: "https://ja.wikipedia.org/wiki/%E3%81%8A%E5%AC%A2%E6%A7%98%E7%B5%84%E6%9B%B2", flex: 12 },
				{ year: '2003年', title: 'ぱすてるキッチン', maker: '戯画', duties: ['イベントCG','パッケージCG','テレカCG'], flex: 6 },
				{ year: '2002年', title: 'AQUA BLUE', maker: '戯画', duties: ['彩色マニュアル','色彩設計','イベントCG'], flex: 6 },
				{ year: '2002年', title: 'knot', maker: 'feng', duties: ['パッケージCG'], flex: 6 },
				{ year: '2002年', title: 'バルドフォース', maker: '戯画', duties: ['イベントCG'], flex: 6 },
				{ year: '2002年', title: 'V.G.Re-birthダッシュ', maker: '戯画', duties: ['テレカCG'], flex: 6 },
				{ year: '2002年', title: '夏の日のレザナンス', maker: '(オリジナル同人ゲーム)', duties: ['シナリオ','グラフィック','スクリプト'], link: "https://www.vector.co.jp/soft/win95/game/se247420.html",  flex: 12 },
				{ year: '2001年', title: 'Nursery Song', maker: 'Cronus', duties: ['イベントCG'], flex: 6 },
			],
		}),
	}
</script>
